import * as types from '../mutation-types'

export default {
    namespaced: true,
    state:{
        visits: [],
        visitsOrder: []
    },

    actions:{
        fetchAll({ commit }){
            return window.axios.get('/visits').then((response) => {
                commit(types.STORE_VISITS, response.data);

                return response.data;
            })
        },

        fetchByDay({ commit }, { day }){
            return window.axios.get('/visits', {
                params:{
                    day
                }
            })
            .then((response) => {
                return response.data;
            })
        },

        delete({ commit }, { id }) {
            return window.axios.delete(`/visits/${id}`)
        },

        fetchByFilter({ commit }, { entityTypeId, fromDate, toDate, entityType, regionIds, employeeIds, entityIds, entityName, specialtyId, workload, page, PerPage, OrderByWorkLoad, OrderByName, IsMedicalRep, visitId }){
            var urlSearchParams = new URLSearchParams();
            var params = { entityTypeId, fromDate, toDate, entityType, entityName, specialtyId, workload, page, PerPage, OrderByWorkLoad, OrderByName, IsMedicalRep, visitId };

            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) {
                    urlSearchParams.append(param, params[param]);
                } 
            })
            if (regionIds.length) {
                regionIds.forEach(id => {
                    urlSearchParams.append("regionIds", id);
                });
            } 
            if (employeeIds.length) {
                employeeIds.forEach(id => {
                    urlSearchParams.append("employeeIds", id);
                })
            }

            if (entityIds?.length) {
                entityIds.forEach(id => {
                    urlSearchParams.append("entityIds", id);
                })
            }
            
            return window.axios.get('/visits', {
                params: urlSearchParams
            })
            .then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                };
            })
        },

        fetchById({ commit }, { id }){
            return window.axios.get(`/visits/${id}`).then((response) => {
                return response.data;
            })
        },

        fetchVisitsWithoutPagination({ commit }, { fromDate, toDate, employeeId, regionIds, specialtyId }) {
            const urlSearchParams = new URLSearchParams();

            const params = { fromDate, toDate, employeeId, specialtyId };
            Object.keys(params).forEach(param => {
                if (params[param]) urlSearchParams.append(param, params[param]);
            })
            if (Array.isArray(regionIds)) {
                regionIds.forEach(id => urlSearchParams.append('regionIds', id))
            }

            return window.axios.get('/visits/BetweenTwoDates', { params: urlSearchParams }).then(({ data }) => {
                return data
            })
        },

        fetchVisitsOrder({ commit }, { FromDate, ToDate, RegionIds, EmployeeIds, Page, PerPage }) {
            const urlSearchParams = new URLSearchParams();
            var params = { FromDate, ToDate, Page, PerPage };
            Object.keys(params).forEach(param => {
                if (params[param]) urlSearchParams.append(param, params[param]);
            })
            if (Array.isArray(RegionIds)) {
                RegionIds.forEach(id => urlSearchParams.append('regionIds', id))
            }

            EmployeeIds.forEach(id => urlSearchParams.append('EmployeeIds', id))
			return window.axios.get('/Visits/OrderdVisits', { 
                params: urlSearchParams
            }).then(({ data }) => {
                commit(types.STORE_VISITS_ORDER, data)
                return data
			})
		},

        updateVisit({ commit }, { id, entityId, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, createdAt, coreMessage, durationInMinutes, residentDoctorNames }) 
        {
            return window.axios.put(`/visits/${id}`, { id, entityId, otherSamples, notes, objections, nextVisitNotes, purpose, materialAmounts, unavailableMaterialIds, competitiveSamples, createdAt, coreMessage, durationInMinutes, residentDoctorNames }).then(({ data }) => {
                return data
            })
        },

        fetchDebtVisits ({ commit }, { fromDate, toDate, employeeId, entityIds, regionIds, perPage, page }) {
            const urlSearchParams = new URLSearchParams();
            var params = { fromDate, toDate, employeeId, perPage, page };
            Object.keys(params).forEach(param => {
                if (params[param]) urlSearchParams.append(param, params[param]);
            })
            if (Array.isArray(regionIds)) {
                regionIds.forEach(id => urlSearchParams.append('regionIds', id))
            }
            if (Array.isArray(entityIds)) {
                entityIds.forEach(id => urlSearchParams.append('entityIds', id))
            }
            
            return window.axios.get('/visits/debtVisit', { params: urlSearchParams }).then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                };
            })
        },

        updateAmountReceived ({ commit }, { id, newAmount }) {
            return window.axios.put(`/visits/${id}/modifyVisitAmountReceived`, newAmount, { headers: { 'Content-Type': 'application/json' } }).then(({ data }) => {
                return data
            })
        },

        updatePaymentMethod ({ commit }, { id, paymentType }) {
            return window.axios.put(`/visits/${id}/modifyVisitPaymentType`, paymentType, { headers: { 'Content-Type': 'application/json' } }).then(({ data }) => {
                return data
            })
        }
    },

    mutations:{
        [types.STORE_VISITS](state, visits){
            state.visits = visits;
        },

        [types.STORE_VISITS_ORDER] (state, visitsOrder) {
			state.visitsOrder = visitsOrder
		}
    },

    getters:{
        getVisitById: state => id => state.visits.find(c => c.id === id),
        getVisitOrderByMedicalRep: state => employeeId => state.visitsOrder.find(c => c.employeeId === employeeId)
    }
}